import { VariantsState } from 'editor/src/store/variants/types';

const setVariantsAreLoadingReducer = (state: VariantsState) => {
  state.isVariantFlow = true;
};

export default setVariantsAreLoadingReducer;
